import { c as _c } from "react/compiler-runtime";
import 'src/@7f-ui/ui-storyblok/src/components/storyblok-client-runtime';
import type { ISbStoryData } from '@storyblok/react';
import { StoryblokComponent } from '@storyblok/react';
type Props = {
  field?: string;
  story: ISbStoryData;
  __pageData?: unknown;
};
export function StoryblokComponents(t0) {
  const $ = _c(10);
  const {
    story,
    field,
    __pageData
  } = t0;
  const components = field ? story.content[field] : story.content;
  if (!components) {
    return null;
  }
  if (!Array.isArray(components)) {
    let t1;
    if ($[0] !== __pageData || $[1] !== components) {
      t1 = {
        ...components,
        __pageData
      };
      $[0] = __pageData;
      $[1] = components;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] !== story || $[4] !== t1) {
      t2 = <StoryblokComponent blok={t1} story={story} />;
      $[3] = story;
      $[4] = t1;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  let t1;
  if ($[6] !== components) {
    t1 = components.map(_temp);
    $[6] = components;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== t1) {
    t2 = <>{t1}</>;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
}
function _temp(component) {
  return <StoryblokComponent blok={component} key={component._uid} />;
}